const Cold = (props: React.SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
		<path
			fillRule="evenodd"
			d="M0 48.52c0-1.657 1.244-3 2.778-3h61.11c8.683 0 15.742 7.623 15.742 17 0 9.377-7.059 17-15.741 17-8.682 0-15.74-7.623-15.74-17v-2c0-1.657 1.243-3 2.777-3s2.778 1.343 2.778 3v2c0 6.063 4.57 11 10.185 11 5.614 0 10.185-4.937 10.185-11s-4.571-11-10.185-11H2.778c-1.534 0-2.778-1.343-2.778-3ZM48.148 22.52c0-9.382 7.101-17 15.741-17 8.645 0 15.74 7.663 15.74 17 0 9.382-7.1 17-15.74 17h-35c-1.534 0-2.778-1.343-2.778-3s1.244-3 2.778-3h35c5.582 0 10.185-4.942 10.185-11 0-6.023-4.608-11-10.185-11-5.582 0-10.185 4.942-10.185 11v2c0 1.657-1.244 3-2.778 3s-2.778-1.343-2.778-3v-2ZM0 36.52c0-1.657 1.244-3 2.778-3h11.037c1.534 0 2.778 1.343 2.778 3s-1.244 3-2.778 3H2.778c-1.534 0-2.778-1.343-2.778-3Z"
			clipRule="evenodd"
		/>
		<path
			fillRule="evenodd"
			d="M17.111 13.76C17.111 6.19 22.792 0 29.851 0c7.01 0 12.742 6.136 12.742 13.76 0 7.57-5.682 13.76-12.741 13.76H2.778c-1.534 0-2.778-1.343-2.778-3s1.244-3 2.778-3h27.074c3.978 0 7.185-3.49 7.185-7.76 0-4.296-3.231-7.76-7.185-7.76-3.978 0-7.185 3.49-7.185 7.76v1.52c0 1.657-1.244 3-2.778 3s-2.778-1.343-2.778-3v-1.52Z"
			clipRule="evenodd"
		/>
	</svg>
);
export default Cold;
